/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { userActionLogControllerDelete } from '../fn/user-action-log/user-action-log-controller-delete';
import { UserActionLogControllerDelete$Params } from '../fn/user-action-log/user-action-log-controller-delete';
import { userActionLogControllerFindAll } from '../fn/user-action-log/user-action-log-controller-find-all';
import { UserActionLogControllerFindAll$Params } from '../fn/user-action-log/user-action-log-controller-find-all';
import { userActionLogControllerFindById } from '../fn/user-action-log/user-action-log-controller-find-by-id';
import { UserActionLogControllerFindById$Params } from '../fn/user-action-log/user-action-log-controller-find-by-id';
import { userActionLogControllerSearchCursor } from '../fn/user-action-log/user-action-log-controller-search-cursor';
import { UserActionLogControllerSearchCursor$Params } from '../fn/user-action-log/user-action-log-controller-search-cursor';
import { userActionLogControllerSearchOffset } from '../fn/user-action-log/user-action-log-controller-search-offset';
import { UserActionLogControllerSearchOffset$Params } from '../fn/user-action-log/user-action-log-controller-search-offset';
import { userActionLogControllerUpdate } from '../fn/user-action-log/user-action-log-controller-update';
import { UserActionLogControllerUpdate$Params } from '../fn/user-action-log/user-action-log-controller-update';
import { UserActionLogDto } from '../models/user-action-log-dto';

@Injectable({ providedIn: 'root' })
export class UserActionLogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userActionLogControllerFindAll()` */
  static readonly UserActionLogControllerFindAllPath = '/api/user-action-log';

  /**
   * 사용자 로그 전체 조회.
   *
   * 사용자 로그 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userActionLogControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  userActionLogControllerFindAll$Response(params?: UserActionLogControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserActionLogDto>>> {
    return userActionLogControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 사용자 로그 전체 조회.
   *
   * 사용자 로그 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userActionLogControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userActionLogControllerFindAll(params?: UserActionLogControllerFindAll$Params, context?: HttpContext): Observable<Array<UserActionLogDto>> {
    return this.userActionLogControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserActionLogDto>>): Array<UserActionLogDto> => r.body)
    );
  }

  /** Path part for operation `userActionLogControllerSearchOffset()` */
  static readonly UserActionLogControllerSearchOffsetPath = '/api/user-action-log/{id}/search/offset';

  /**
   * 사용자 로그 오프셋 기반 조회.
   *
   * 사용자 로그을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userActionLogControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  userActionLogControllerSearchOffset$Response(params: UserActionLogControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return userActionLogControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 사용자 로그 오프셋 기반 조회.
   *
   * 사용자 로그을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userActionLogControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userActionLogControllerSearchOffset(params: UserActionLogControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.userActionLogControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `userActionLogControllerSearchCursor()` */
  static readonly UserActionLogControllerSearchCursorPath = '/api/user-action-log/{id}/search/cursor';

  /**
   * 사용자 로그 커서 기반 조회.
   *
   * 사용자 로그을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userActionLogControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  userActionLogControllerSearchCursor$Response(params: UserActionLogControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return userActionLogControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 사용자 로그 커서 기반 조회.
   *
   * 사용자 로그을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userActionLogControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userActionLogControllerSearchCursor(params: UserActionLogControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.userActionLogControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `userActionLogControllerFindById()` */
  static readonly UserActionLogControllerFindByIdPath = '/api/user-action-log/{id}';

  /**
   * 사용자 로그 ID 기반 조회.
   *
   * 사용자 로그을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userActionLogControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  userActionLogControllerFindById$Response(params: UserActionLogControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<UserActionLogDto>> {
    return userActionLogControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 사용자 로그 ID 기반 조회.
   *
   * 사용자 로그을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userActionLogControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userActionLogControllerFindById(params: UserActionLogControllerFindById$Params, context?: HttpContext): Observable<UserActionLogDto> {
    return this.userActionLogControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserActionLogDto>): UserActionLogDto => r.body)
    );
  }

  /** Path part for operation `userActionLogControllerDelete()` */
  static readonly UserActionLogControllerDeletePath = '/api/user-action-log/{id}';

  /**
   * 사용자 로그 삭제.
   *
   * 사용자 로그을(를) 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userActionLogControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  userActionLogControllerDelete$Response(params: UserActionLogControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<UserActionLogDto>> {
    return userActionLogControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 사용자 로그 삭제.
   *
   * 사용자 로그을(를) 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userActionLogControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userActionLogControllerDelete(params: UserActionLogControllerDelete$Params, context?: HttpContext): Observable<UserActionLogDto> {
    return this.userActionLogControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserActionLogDto>): UserActionLogDto => r.body)
    );
  }

  /** Path part for operation `userActionLogControllerUpdate()` */
  static readonly UserActionLogControllerUpdatePath = '/api/user-action-log/{id}';

  /**
   * 사용자 로그 수정.
   *
   * 사용자 로그을(를) 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userActionLogControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userActionLogControllerUpdate$Response(params: UserActionLogControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<UserActionLogDto>> {
    return userActionLogControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 사용자 로그 수정.
   *
   * 사용자 로그을(를) 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userActionLogControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userActionLogControllerUpdate(params: UserActionLogControllerUpdate$Params, context?: HttpContext): Observable<UserActionLogDto> {
    return this.userActionLogControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserActionLogDto>): UserActionLogDto => r.body)
    );
  }

}
